module.exports = new __parcel__URL__("ummagumma.d915e91a.jpg").toString();